import { Fragment, PropsWithChildren } from "react";

type ConditionalRendererProps = {
  condition: boolean;
};

export function ConditionalRenderer({
  condition,
  children,
}: PropsWithChildren<ConditionalRendererProps>) {
  return condition ? <>{children}</> : <Fragment></Fragment>;
}
